import styledBurgerEffect from '~/components/header/styled-burger-effect.js';

const Burger = styledBurgerEffect`
	border: none;
	background-color: transparent;
	width: 24px;
	margin: 0 8px 0 0;
	.icon--sprite {
		fill: var(--hamburger-menu);
		margin-top: 2px;
	}
	&:focus {
		outline: none;
	}
`;

export default Burger;
